import {BehaviorSubject} from "rxjs";
import {OrderTransferTargetStatus} from "./order-transfer-request-poll.service";
import {OrderTransferTargetData} from "./order-transfer-target-entity.model";

export class GroupOrderEvents {

    /**
     * Notifies the current group order status.
     */
    public static readonly groupOrderStatus$: BehaviorSubject<OrderTransferTargetStatus> = new BehaviorSubject(OrderTransferTargetStatus.CLOSED);

    /**
     * Notifies the current group order.
     */
    public static readonly currentGroupOrder$: BehaviorSubject<OrderTransferTargetData> = new BehaviorSubject(undefined);
}



// WEBPACK FOOTER //
// ./src/app/group-order/group-order-events.ts